import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { FlyoutContent } from '@amzn/atoz-web/Flyout';
export var FilterFlyoutContent = function (children, onFilterReset) {
    var FilterFlyoutContentWithChildren = function (_a) {
        var close = _a.close;
        var t = useTranslation().t;
        return (React.createElement(FlyoutContent, { titleText: "Filter Shifts", dataTestId: "filters-flyout-content", buttons: [
                React.createElement(Button, { variant: ButtonVariant.Tertiary, onClick: onFilterReset, dataTestId: "filter-flyout-reset", key: "reset-filters" }, "Reset"),
                React.createElement(Button, { onClick: close, dataTestId: "view-shifts-filters-button", key: "view-shifts" }, t('ess_findshifts_filters_viewShifts'))
            ], onCloseButtonClick: close }, children));
    };
    return FilterFlyoutContentWithChildren;
};
